import { render, staticRenderFns } from "./HomeBottom.vue?vue&type=template&id=dd6526d4&"
import script from "./HomeBottom.vue?vue&type=script&lang=js&"
export * from "./HomeBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports